var map = {
	"./symbol_0.png": 30409,
	"./symbol_1.png": 59232,
	"./symbol_10.png": 12514,
	"./symbol_11.png": 33643,
	"./symbol_12.png": 80144,
	"./symbol_13.png": 60697,
	"./symbol_14.png": 83974,
	"./symbol_15.png": 6639,
	"./symbol_16.png": 87732,
	"./symbol_17.png": 8861,
	"./symbol_2.png": 37563,
	"./symbol_3.png": 39698,
	"./symbol_4.png": 95853,
	"./symbol_5.png": 55908,
	"./symbol_6.png": 10559,
	"./symbol_7.png": 14230,
	"./symbol_8.png": 42513,
	"./symbol_9.png": 28296
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 83460;